<template>
  <div>
    <!-- Header -->
    <div class="header py-7 py-lg-8 pt-lg-9 bg-price">
      <div class="container">
        <div class="header-body text-center mb-5">
          <div class="row justify-content-center">
            <div class="col px-5">
              <h1 class="display-3 text-white">Безлимитные подписки</h1>
              <h3 class="text-white">Две недели бесплатно после регистрации</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div class="pricing card-group flex-column flex-md-row mb-3">

            <card header-classes="bg-transparent" body-classes="" class="card-pricing border-0 text-center mb-4">
              <h1 slot="header" class="ls-1 text-green mb-0">1</h1>
              <h4 slot="header" class="text-uppercase ls-1 text-green mb-0">месяц</h4>
              <h2>299 ₽</h2>
              <p>299 ₽ в месяц</p>
              <!--<div slot="footer">Оплатить картой</div>-->
            </card>

            <card gradient="danger" class="card-pricing zoom-in shadow-lg rounded border-0 text-center mb-4"
                  header-classes="bg-transparent"
                  body-classes="text-white"
                  footer-classes="bg-transparent">
              <h1 slot="header" class="ls-1 text-white mb-0">3</h1>
              <h4 slot="header" class="text-uppercase ls-1 text-white mb-0">месяца</h4>
              <h2 class="text-white">765 ₽</h2>
              <p>255 ₽ в месяц</p>
            </card>

            <card header-classes="bg-transparent" body-classes="" class="card-pricing border-0 text-center mb-4">
              <h1 slot="header" class="ls-1 text-green mb-0">6</h1>
              <h4 slot="header" class="text-uppercase ls-1 text-green mb-0">месяцев</h4>
              <h2>1 440 ₽</h2>
              <p>240 ₽ в месяц</p>
            </card>

            <card header-classes="bg-transparent" body-classes="" class="card-pricing border-0 text-center mb-4">
              <h1 slot="header" class="ls-1 text-green mb-0">12</h1>
              <h4 slot="header" class="text-uppercase ls-1 text-green mb-0">месяцев</h4>
              <h2>2 520 ₽</h2>
              <p>210 ₽ в месяц</p>
            </card>

          </div>
        </div>
      </div>

      <div class="row justify-content-center mb-5">
        <div class="col text-center">
          <h1 class="display-3 text-center">Пакеты подписаний</h1>
          <h3>+ 10 подписаний когда безлимитная подписка закончится</h3>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div class="pricing card-group flex-column flex-md-row mb-3">

            <card header-classes="bg-transparent" body-classes="" class="card-pricing border-0 text-center mb-4">
              <h1 slot="header" class="ls-1 text-green mb-0">10</h1>
              <h4 slot="header" class="text-uppercase ls-1 text-green mb-0">подписаний</h4>
              <h2>199 ₽</h2>
              <p>Бессрочно<br/>19.90 ₽ за документ</p>
            </card>

            <card header-classes="bg-transparent" body-classes="" class="card-pricing border-0 text-center mb-4">
              <h1 slot="header" class="ls-1 text-green mb-0">50</h1>
              <h4 slot="header" class="text-uppercase ls-1 text-green mb-0">подписаний</h4>
              <h2>710 ₽</h2>
              <p>Бессрочно<br/>14.20 ₽ за документ</p>
            </card>

            <card header-classes="bg-transparent" body-classes="" class="card-pricing border-0 text-center mb-4">
              <h1 slot="header" class="ls-1 text-green mb-0">100</h1>
              <h4 slot="header" class="text-uppercase ls-1 text-green mb-0">подписаний</h4>
              <h2>1 065 ₽</h2>
              <p>Бессрочно<br/>10.65 ₽ за документ</p>
            </card>

            <card header-classes="bg-transparent" body-classes="" class="card-pricing border-0 text-center mb-4">
              <h1 slot="header" class="ls-1 text-green mb-0">500</h1>
              <h4 slot="header" class="text-uppercase ls-1 text-green mb-0">подписаний</h4>
              <h2>3 990 ₽</h2>
              <p>Бессрочно<br/>7.98 ₽ за документ</p>
            </card>

          </div>
        </div>
      </div>

      <div class="row justify-content-center mb-5">
        <div class="col text-center">
          <h3>Пополнить баланс картой, подключить подписку или пакет можно внутри приложения</h3>
          <img src="img/screens/billing.png">
        </div>
      </div>

      <!--
      <div class="d-flex justify-content-lg-center px-3 mt-5">
        <div>
          <div class="icon icon-shape bg-gradient-white shadow rounded-circle text-primary">
            <i class="ni ni-building text-primary"></i>
          </div>
        </div>
        <div class="col-lg-6">
          <p class="text-white"><strong>The Arctic Ocean</strong> freezes every winter and much of the sea-ice then
            thaws
            every summer, and that process will continue whatever.</p>
        </div>
      </div>


      <div class="row row-grid justify-content-center">
        <div class="col-lg-10">
          <div class="table-responsive">
            <base-table class="table table-dark mt-5"
                        :data="features">
              <template slot="columns">
                <th class="px-0 bg-transparent" scope="col">
                  <span class="text-light font-weight-700">Features</span>
                </th>
                <th class="text-center bg-transparent" scope="col">Bravo Pack</th>
                <th class="text-center bg-transparent" scope="col">Alpha Pack</th>
              </template>

              <template slot-scope="{row}">
                <td class="px-0">{{row.title}}</td>
                <td class="text-center" v-html="row.bravo"></td>
                <td class="text-center" v-html="row.alpha"></td>
              </template>

            </base-table>
          </div>
        </div>
      </div>
      -->

    </div>

  </div>
</template>
<script>
  import BaseTable from '@/components/BaseTable';
  export default {
    name: 'pricing-page',
    components: {
      BaseTable
    },
    data() {
      return {
        features: [
          {
            title: 'IMAP/POP Support',
            bravo: '<i class="fas fa-check text-success"></i>',
            alpha: '<i class="fas fa-check text-success"></i>'
          },
          {
            title: 'Email Forwarding',
            bravo: '<i class="fas fa-check text-success"></i>',
            alpha: '<i class="fas fa-check text-success"></i>'
          },
          {
            title: 'Active Sync',
            bravo: '<i class="fas fa-check text-success"></i>',
            alpha: '<i class="fas fa-check text-success"></i>'
          },
          {
            title: 'Multiple domain hosting',
            bravo: '<i class="fas fa-check text-success"></i>',
            alpha: '<span class="text-sm text-light">Limited to 1 domain only</span>'
          },
          {
            title: 'Additional storage upgrade',
            bravo: '<i class="fas fa-check text-success"></i>',
            alpha: '<i class="fas fa-check text-success">'
          },
          {
            title: '30MB Attachment Limit',
            bravo: '<i class="fas fa-check text-success"></i>',
            alpha: '-'
          },
          {
            title: 'Password protected / Expiry links',
            bravo: '<i class="fas fa-check text-success"></i>',
            alpha: '-'
          },
          {
            title: 'Unlimited Custom Apps',
            bravo: '<i class="fas fa-check text-success"></i>',
            alpha: '-'
          }
        ]
      }
    }
  };
</script>
<style>
  .bg-price {
    background-image: url(/img/bg-price.jpg);
    background-size: cover;
    background-position: center top;
    min-height: 400px;
  }
</style>
